
<template>
    <v-container fluid>
        <v-slide-y-transition mode="out-in">

            <v-layout column>
                <v-card-title>
                    <v-btn text @click="storePendentes.load()"><v-icon left>refresh</v-icon>Atualizar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="search"
                        label="Pesquisar"
                        clearable
                        single-line
                    ></v-text-field>
                </v-card-title>

                <v-sheet height="600">
                  <v-calendar
                    ref="calendar"
                    v-model="value"
                    :weekdays="weekday"
                    :type="type"
                    :events="events"
                    :event-overlap-mode="mode"
                    :event-overlap-threshold="30"
                    :event-color="getEventColor"
                    @change="getEvents"
                  ></v-calendar>
                </v-sheet>
            </v-layout>
        </v-slide-y-transition>
    </v-container>
</template>

<script>

import Utils from '@/utils/Utils.js';
import { EventBus } from '@/EventBus.js';
import moment from 'moment';
import { Store } from '@/utils/Store.js';

export default {
    mounted() {
        EventBus.$on('tarefaInserida', (eventParam) => {
            this.storePendentes.load();
        });
        EventBus.$on('tarefaAlterada', (eventParam) => {
            this.storePendentes.load();
        });
        EventBus.$on('tarefaRemovida', (eventParam) => {
            this.storePendentes.load();
        });
    },
    methods: {
        toTarefaDetalhes(id) {
            EventBus.$emit('showTarefaDetalhes', {
                id: id
            });
        },
        getEvents ({ start, end }) {
            const events = [];

            const min = moment().startOf('month').toDate();
            const max = moment().endOf('month').toDate();
            const days = (max.getTime() - min.getTime()) / 86400000;
            const eventCount = this.rnd(days, days + 20);

            for (let i = 0; i < eventCount; i++) {
                const allDay = this.rnd(0, 3) === 0;
                const firstTimestamp = this.rnd(min.getTime(), max.getTime());
                const first = new Date(firstTimestamp - (firstTimestamp % 900000));
                const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
                const second = new Date(first.getTime() + secondTimestamp);

                events.push({
                    name: this.names[this.rnd(0, this.names.length - 1)],
                    start: first,
                    end: second,
                    color: this.colors[this.rnd(0, this.colors.length - 1)],
                    timed: !allDay
                });
            }

            this.events = events;
        },
        getEventColor (event) {
            return event.color;
        },
        rnd (a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a;
        }
    },
    created() {
        this.storePendentes.load();
    },
    data() {
        return {
            storePendentes: new Store({ url: '/tarefas/Tarefas' }),
            isTrue: true,
            search: '',
            type: 'month',
            types: ['month', 'week', 'day', '4day'],
            mode: 'stack',
            modes: ['stack', 'column'],
            weekday: [0, 1, 2, 3, 4, 5, 6],
            weekdays: [
                { text: 'Sun - Sat', value: [0, 1, 2, 3, 4, 5, 6] },
                { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] },
                { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
                { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
            ],
            value: '',
            events: [],
            colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
            names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party']
        };
    }
}
</script>